import { render, staticRenderFns } from "./SongConversations.vue?vue&type=template&id=0c66efc0&"
import script from "./SongConversations.vue?vue&type=script&lang=js&"
export * from "./SongConversations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports